import { Switch, Picker } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PreviewAppointmentOrder.less';

export default class PreviewAppointmentOrder extends OfficialPage {
  state = {
    goodsList: [],
    selectAddress: {},
    appointment_user_name: '',
    appointment_user_phone: '',
    discountList: [],
    selectDiscountInfo: {},
    selectDiscountIndex: '',
    orderRemark: '',
    is_self_delivery: 0,
    express_fee: '',
    balance: '',
    useBalance: true,
    deduction: '',
    discount_cut_price: '',
    original_price: '',
    totalPayment: '',
    shopAddress: '',
    noAdditionalInfo: true,
    is_group: '',
    to_store: '',
    exchangeCouponData: {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    }
  }
  isFromSelectAddress = false
  hasRequiredSuppInfo = false
  franchisee_id = ''
  cart_id_arr = []
  cart_data_arr = []
  requesting = false
  additional_info = {}
  is_group = ''

  constructor(props) {
    super(props);
    document.title = '确认支付';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.franchisee_id = options.franchisee || ''
    this.cart_id_arr = options.cart_arr
      ? decodeURIComponent(options.cart_arr).split(',')
      : []
    this.dataInitial()
    this.is_group = options.is_group || ''
    this.setData({
      is_group: this.is_group,
      to_store: options.to_store ? JSON.parse(options.to_store) : ''
    })
  }

  dataInitial = () => {
    this.getCalculationInfo()
    this.getShopAddress()
    this.getCartList()
  }

  componentDidMount() {
    if (this.isFromSelectAddress) {
      this.getCalculationInfo()
      this.isFromSelectAddress = false
    }
  }

  getCartList = () => {
    var that = this,
      franchisee_id = this.franchisee_id
    app.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 100,
        sub_shop_app_id: franchisee_id,
        parent_shop_app_id: franchisee_id ? app.globalData.appId : ''
      },
      success: function (res) {
        var data = []
        var startDate, endDate, service_period, intervalDate
        if (that.cart_id_arr.length) {
          for (var i = 0; i <= res.data.length - 1; i++) {
            if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
              data.push(res.data[i])
            }
          }
        } else {
          data = res.data
        }
        for (var i = 0; i <= data.length - 1; i++) {
          var goods = data[i],
            modelArr = goods.model_value
          goods.model_value_str =
            modelArr && modelArr.join ? '(' + modelArr.join('|') + ')' : ''
          that.cart_data_arr.push({
            cart_id: goods.id,
            goods_id: goods.goods_id,
            model_id: goods.model_id,
            num: goods.num
          })
        }
        startDate = {
          month: data[0].appointment_start.substring(4, 6),
          day: data[0].appointment_start.substring(6, 8),
          hours: data[0].appointment_start.substring(8)
        }
        endDate = {
          month: data[0].appointment_end.substring(4, 6),
          day: data[0].appointment_end.substring(6, 8),
          hours: data[0].appointment_end.substring(8)
        }
        intervalDate =
          endDate.day > startDate.day || endDate.month > startDate.month
            ? endDate.month + '月' + endDate.day + '日'
            : '当日'
        service_period =
          startDate.month +
          '月' +
          startDate.day +
          '日 ' +
          startDate.hours +
          ' - ' +
          intervalDate +
          endDate.hours
        that.setData({
          goodsList: data,
          service_period: service_period
        })
      }
    })
  }
  getCalculationInfo = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: {
        sub_shop_app_id: this.franchisee_id,
        address_id: this.data.selectAddress.id,
        cart_id_arr: this.cart_id_arr,
        is_balance: this.data.useBalance ? 1 : 0,
        is_self_delivery: this.data.is_self_delivery,
        selected_benefit: this.data.selectDiscountInfo,
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info
      },
      success: function (res) {
        var info = res.data,
          benefits = info.can_use_benefit.data,
          goods_info = info.goods_info,
          need_user_address = goods_info[0].appointment_info.need_user_address,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          suppInfoArr = [],
          selectDiscountIndex,
          selectDiscountInfo
        if (benefits && benefits.length) {
          benefits.unshift({
            title: '不使用优惠',
            name: '无',
            no_use_benefit: 1
          })
        }
        if (
          _this.data.selectDiscountInfo &&
          _this.data.selectDiscountInfo.no_use_benefit == 1
        ) {
          selectDiscountInfo = _this.data.selectDiscountInfo
          selectDiscountIndex = 0
        } else {
          selectDiscountInfo = info.selected_benefit_info
          if (selectDiscountInfo && selectDiscountInfo.discount_type) {
            for (var i = 0; i <= benefits.length - 1; i++) {
              if (
                selectDiscountInfo.discount_type === benefits[i].discount_type
              ) {
                if (selectDiscountInfo.discount_type === 'coupon') {
                  if (selectDiscountInfo.coupon_id === benefits[i].coupon_id) {
                    selectDiscountIndex = i
                    break
                  }
                } else {
                  selectDiscountIndex = i
                  break
                }
              }
            }
            if (
              selectDiscountInfo.discount_type == 'coupon' &&
              selectDiscountInfo.type == 3 &&
              _this.data.exchangeCouponData.hasSelectGoods == false
            ) {
              _this.exchangeCouponInit(parseInt(selectDiscountInfo.value))
            }
          }
        }
        for (var i = 0; i <= goods_info.length - 1; i++) {
          if (
            goods_info[i].delivery_id &&
            goods_info[i].delivery_id != 0 &&
            additional_goodsid_arr.indexOf(goods_info[i].id) == -1
          ) {
            suppInfoArr.push(goods_info[i].delivery_id)
            additional_goodsid_arr.push(goods_info[i].id)
            additional_info_goods.push(goods_info[i])
          }
        }
        _this.setData({
          selectAddress: info.address || {},
          discountList: benefits || [],
          selectDiscountIndex: selectDiscountIndex || '',
          selectDiscountInfo: selectDiscountInfo || '',
          express_fee: info.express_fee,
          discount_cut_price: info.discount_cut_price,
          balance: info.balance,
          deduction: info.use_balance,
          original_price: info.original_price || '免费',
          totalPayment: info.price,
          noAdditionalInfo: suppInfoArr.length ? false : true,
          need_user_address: need_user_address
        })
        if (suppInfoArr.length && !_this.hasRequiredSuppInfo) {
          _this.getSuppInfo(suppInfoArr)
        }
        app.setPreviewGoodsInfo(additional_info_goods)
      },
      successStatusAbnormal: function (res) {
        setTimeout(() => {
          app.turnBack()
        }, 2000)
      }
    })
  }
  getShopAddress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      success: function (res) {
        that.setData({
          shopAddress: res.data
        })
      }
    })
  }
  remarkInput = e => {
    var value = e.target.value
    this.setData({
      orderRemark: value
    })
  }
  previewImage = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src
    })
  }
  clickMinusButton = e => {
    var index = e.currentTarget.dataset.index,
      goods = this.data.goodsList[index]
    if (+goods.num <= 0) return
    this.changeGoodsNum(index, 'minus')
  }
  clickPlusButton = e => {
    var index = e.currentTarget.dataset.index
    this.changeGoodsNum(index, 'plus')
  }
  changeGoodsNum = (index, type) => {
    var goods = this.data.goodsList[index],
      currentNum = +goods.num,
      targetNum = type == 'plus' ? currentNum + 1 : currentNum - 1,
      that = this,
      data = {},
      param
    if (targetNum == 0 && type == 'minus') {
      app.showModal({
        content: '确定从购物车删除该商品？',
        showCancel: true,
        confirm: function () {
          that.cart_data_arr[index].num = targetNum
          data['goodsList[' + index + '].num'] = targetNum
          that.setData(data)
          that.deleteGoods(index)
        }
      })
      return
    }
    param = {
      goods_id: goods.goods_id,
      model_id: goods.model_id || '',
      num: targetNum,
      sub_shop_app_id: that.franchisee_id,
      is_seckill: goods.is_seckill == 1 ? 1 : ''
    }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        that.cart_data_arr[index].num = targetNum
        data['goodsList[' + index + '].num'] = targetNum
        data.selectDiscountInfo = ''
        that.setData(data)
        that.getCalculationInfo()
      },
      fail: function (res) {
        data = {}
        that.cart_data_arr[index].num = currentNum
        data['goodsList[' + index + '].num'] = currentNum
        that.setData(data)
      }
    })
  }
  deleteGoods = index => {
    var goodsList = this.data.goodsList,
      that = this,
      listExcludeDelete
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: {
        cart_id_arr: [this.cart_data_arr[index].cart_id],
        sub_shop_app_id: this.franchisee_id
      },
      success: function (res) {
        ; (listExcludeDelete = goodsList.concat([])).splice(index, 1)
        if (listExcludeDelete.length == 0) {
          app.turnBack()
          return
        }
        var deleteGoodsId = goodsList[index],
          noSameGoodsId = true
        for (var i = listExcludeDelete.length - 1; i >= 0; i--) {
          if (listExcludeDelete[i].id == deleteGoodsId) {
            noSameGoodsId = false
            break
          }
        }
        if (noSameGoodsId) {
          delete that.additional_info[deleteGoodsId]
        }
        that.cart_data_arr.splice(index, 1)
        that.setData({
          goodsList: listExcludeDelete,
          selectDiscountInfo: ''
        })
        that.getCalculationInfo()
      }
    })
  }
  confirmPayment = e => {
    var list = this.data.goodsList,
      that = this,
      selected_benefit = this.data.selectDiscountInfo,
      hasWritedAdditionalInfo = false
    if (
      this.data.need_user_address != '0' &&
      this.data.is_self_delivery == 0 &&
      !this.data.selectAddress.id
    ) {
      app.showModal({
        content: '请添加个人信息'
      })
      return
    }
    for (var key in this.additional_info) {
      if (key !== undefined) {
        hasWritedAdditionalInfo = true
        break
      }
    }
    if (
      this.data.need_user_address == '0' &&
      !(this.data.appointment_user_phone && this.data.appointment_user_name)
    ) {
      app.showModal({
        content: '请填写个人信息'
      })
      return
    }
    if (that.hasRequiredSuppInfo) {
      app.showModal({
        content: '请填写商品补充信息'
      })
      return
    }
    if (this.requesting) {
      return
    }
    this.requesting = true
    app.sendRequest({
      url: '/index.php?r=AppShop/addCartOrder',
      method: 'post',
      data: {
        cart_arr: this.cart_data_arr,
        formId: e.detail.formId,
        sub_shop_app_id: this.franchisee_id,
        selected_benefit: selected_benefit,
        is_balance: this.data.useBalance ? 1 : 0,
        is_self_delivery: this.data.is_self_delivery,
        remark: this.data.orderRemark,
        address_id: this.data.selectAddress.id,
        additional_info: this.additional_info,
        voucher_coupon_goods_info: this.data.exchangeCouponData
          .voucher_coupon_goods_info,
        appointment_to_store_time: this.data.to_store,
        appointment_user_phone: this.data.appointment_user_phone,
        appointment_user_name: this.data.appointment_user_name
      },
      success: function (res) {
        that.payOrder(res.data)
      },
      fail: function () {
        that.requesting = false
      },
      successStatusAbnormal: function () {
        that.requesting = false
      }
    })
  }
  payOrder = orderId => {
    var that = this
    function paySuccess() {
      var pagePath =
        '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' +
        orderId +
        (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') +
        '&is_group=' +
        !!that.is_group +
        '&code=code'
      if (!that.franchisee_id) {
        app.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: that.franchisee_id
          },
          success: function (res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            app.turnToPage(pagePath, 1)
          }
        })
      } else {
        app.turnToPage(pagePath, 1)
      }
    }
    function payFail() {
      app.turnToPage(
        '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' +
        orderId,
        1
      )
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          paySuccess()
        },
        fail: function () {
          payFail()
        },
        successStatusAbnormal: function () {
          payFail()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.goodsType = 1
    //     param.success = paySuccess
    //     param.fail = payFail
    //     that.wxPay(param)
    //   },
    //   fail: function () {
    //     payFail()
    //   },
    //   successStatusAbnormal: function () {
    //     payFail()
    //   }
    // })
    
    let pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&code=code';
    app.goPay({
      orderId: orderId,
      successUrl: pagePath,
      failUrl: '/appointmentOrderDetail?detail=' + orderId,
      cancel: payFail
    });
  }
  // wxPay = param => {
  //   var that = this
  //   app.requestPayment({
  //     timeStamp: param.timeStamp,
  //     nonceStr: param.nonceStr,
  //     package: param.package,
  //     signType: param.signType,
  //     paySign: param.paySign,
  //     success: function (res) {
  //       app.wxPaySuccess(param)
  //       param.success()
  //     },
  //     fail: function (res) {
  //       if (res.errMsg === 'requestPayment:fail cancel') {
  //         app.showModal({
  //           content: '支付已取消',
  //           complete: param.fail
  //         })
  //         return
  //       }
  //       app.showModal({
  //         content: '支付失败',
  //         complete: param.fail
  //       })
  //       app.wxPayFail(param, res.errMsg)
  //     }
  //   })
  // }
  discountChange = checked => {
    console.log(checked)
    let index = checked[0];
    this.setData({
      selectDiscountInfo: this.data.discountList[index],
      selectDiscountIndex: index,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  goToMyAddress = () => {
    var addressId = this.data.selectAddress.id
    this.isFromSelectAddress = true
    app.turnToPage(
      '/eCommerce/pages/myAddress/myAddress?id=' +
      addressId +
      '&need_address=' +
      this.data.need_user_address
    )
  }
  appointmentUserName = e => {
    this.setData({
      appointment_user_name: e.target.value
    })
  }
  appointmentUserPhone = e => {
    this.setData({
      appointment_user_phone: e.target.value
    })
  }
  showAddAddress = () => {
    var _this = this
    this.isFromSelectAddress = true
    app.chooseAddress({
      success: function (res) {
        app.sendRequest({
          method: 'post',
          url: '/index.php?r=AppShop/AddWxAddress',
          data: {
            detailInfo: res.detailInfo || '',
            cityName: res.cityName || '',
            provinceName: res.provinceName || '',
            UserName: res.userName || '',
            telNumber: res.telNumber || '',
            district: res.district || '',
            countyName: res.countyName || ''
          },
          success: function () {
            _this.dataInitial()
          }
        })
      },
      fail: function () {
        app.turnToPage('/eCommerce/pages/addAddress/addAddress')
      }
    })
  }
  makeStorePhoneCall = () => {
    app.makePhoneCall(this.data.shopAddress.shop_contact)
  }
  openStoreLocation = () => {
    var infor =
      this.data.shopAddress.region_string + this.data.shopAddress.shop_location
    infor = infor.replace(/\s/g, '')
    app.sendRequest({
      url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
      data: {
        location_info: infor
      },
      success: function (res) {
        if (res.result) {
          app.openLocation({
            latitude: res.result.location.lat,
            longitude: res.result.location.lng
          })
        }
      }
    })
  }
  useBalanceChange = checked => {
    this.setData({
      useBalance: checked
    })
    this.getCalculationInfo()
  }
  deliveryWayChange = e => {
    this.setData({
      is_self_delivery: e.target.value
    })
    this.getCalculationInfo()
  }
  goToAdditionalInfo = () => {
    app.setGoodsAdditionalInfo(this.additional_info)
    app.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo')
  }
  exchangeCouponInit = id => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: id
      },
      success: function (res) {
        var goods = res.data[0].form_data
        var goodsModel = []
        var selectModelInfo = {
          models: [],
          price: 0,
          modelId: '',
          models_text: '',
          imgurl: ''
        }
        if (goods.model_items.length) {
          selectModelInfo['price'] = Number(goods.model_items[0].price)
          selectModelInfo['imgurl'] = goods.model_items[0].img_url
          selectModelInfo['modelId'] = goods.model_items[0].id
        } else {
          selectModelInfo['price'] = Number(goods.price)
          selectModelInfo['imgurl'] = goods.cover
        }
        for (var key in goods.model) {
          if (key) {
            goodsModel.push(goods.model[key]) // 转成数组
            selectModelInfo['models'].push(goods.model[key].subModelId[0])
            selectModelInfo['models_text'] +=
              '“' + goods.model[key].subModelName[0] + '” '
          }
        }
        goods.model = goodsModel // 将原来的结构转换成数组
        _this.setData({
          'exchangeCouponData.dialogHidden': false, // 显示模态框
          'exchangeCouponData.goodsInfo': goods,
          'exchangeCouponData.selectModelInfo': selectModelInfo
        })
      }
    })
  }
  exchangeCouponHideDialog = () => {
    this.setData({
      selectDiscountInfo: this.data.discountList[0],
      selectDiscountIndex: 0,
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.hasSelectGoods': false,
      'exchangeCouponData.voucher_coupon_goods_info': {}
    })
    this.getCalculationInfo()
  }
  exchangeCouponSelectSubModel = e => {
    var dataset = e.target.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModels = this.data.exchangeCouponData.selectModelInfo.models,
      model = this.data.exchangeCouponData.goodsInfo.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['exchangeCouponData.selectModelInfo.models'] = selectModels
    data['exchangeCouponData.selectModelInfo.models_text'] = text
    this.setData(data)
    this.exchangeCouponResetSelectCountPrice()
  }
  exchangeCouponResetSelectCountPrice = () => {
    var _this = this,
      selectModelIds = this.data.exchangeCouponData.selectModelInfo.models.join(
        ','
      ),
      modelItems = this.data.exchangeCouponData.goodsInfo.model_items,
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock
        data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price
        data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id
        data['exchangeCouponData.selectModelInfo.imgurl'] =
          modelItems[i].img_url
        break
      }
    }
    this.setData(data)
  }
  exchangeCouponConfirmGoods = () => {
    let _this = this
    let goodsInfo = _this.data.exchangeCouponData.goodsInfo
    let model = goodsInfo.model
    let selectModels = _this.data.exchangeCouponData.selectModelInfo.models
    let model_value_str = ''
    if (selectModels.length > 0) {
      model_value_str = '('
      for (let i = 0; i < selectModels.length; i++) {
        let selectSubModelId = model[i].subModelId
        for (let j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            model_value_str += model[i].subModelName[j] + '|'
          }
        }
      }
      model_value_str += ')'
    }
    goodsInfo['model_value_str'] = model_value_str
    _this.setData({
      'exchangeCouponData.dialogHidden': true,
      'exchangeCouponData.selectModelInfo': {},
      'exchangeCouponData.hasSelectGoods': true,
      'exchangeCouponData.voucher_coupon_goods_info': {
        goods_id: goodsInfo.id,
        num: 1,
        model_id: _this.data.exchangeCouponData.selectModelInfo.modelId
      },
      'exchangeCouponData.goodsInfo': goodsInfo
    })
    _this.getCalculationInfo()
  }
  getSuppInfo = suppInfoArr => {
    var _this = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetDelivery',
      method: 'post',
      data: {
        delivery_id: suppInfoArr[0]
      },
      success: function (res) {
        if (res.data) {
          let suppInfo = res.data.delivery_info
          for (let j = 0; j < suppInfo.length; j++) {
            if (suppInfo[j].is_required == 0) {
              _this.hasRequiredSuppInfo = true
              return
            }
          }
        } else {
          _this.setData({
            noAdditionalInfo: true
          })
        }
      }
    })
  }

  render() {
    let {
      showGetUserInfo,
      goodsList,
      is_group,
      service_period,
      original_price,
      exchangeCouponData,
      orderRemark,
      is_self_delivery,
      selectAddress,
      need_user_address,
      appointmentUserName,
      appointmentUserPhone,
      shopAddress,
      selectDiscountIndex,
      discountList,
      selectDiscountInfo,
      discount_cut_price,
      useBalance,
      deduction,
      balance,
      noAdditionalInfo,
      totalPayment,
      dialogHidden,
      selectModelInfo,
      goodsInfo
    } = this.state

    // 处理成Picker组件需要的数据内容
    discountList = discountList.map((item, index) => ({ label: item.title, value: index }))

    return (
      <div className="official-page preview-appointment-order">
        <TopNav title="确认支付"/>
        <div className="preview-goods-order-wrap" id="preview-goods-order">
          <div className="preview-goods-order-list preview-goods-order-section">
            {goodsList.map((goods, goodsIndex) => {
              return (
                <React.Fragment key={goods.id}>
                  <div className="preview-goods-order-item">
                    <img
                      className={
                        'preview-goods-cover ' + (is_group ? 'group-buy' : '')
                      }
                      src={goods.cover}
                      mode="aspectFill"
                    />
                    <div className="preview-goods-content">
                      <div className="preview-goods-title">{goods.title}</div>
                      {goods.model_value_str && (
                        <div className="preview-goods-model">
                          {goods.model_value_str}
                        </div>
                      )}
                      <div className="preview-appointment-service-period">
                        {service_period}
                      </div>
                      <div className="preview-quantity-section">
                        <div className="preview-goods-price">
                          {goods.integral != '2' ? (
                            <React.Fragment>
                              <div className="preview-goods-price">
                                {'¥' +
                                  (original_price == '0'
                                    ? '免费'
                                    : original_price)}
                              </div>
                            </React.Fragment>
                          ) : (
                              <React.Fragment>
                                {!(
                                  goods.use_integral != 0 &&
                                  original_price == '0.00'
                                ) && (
                                    <span>
                                      {original_price == '0.00' &&
                                        goods.use_integral == 0
                                        ? '免费'
                                        : '¥' + original_price}
                                    </span>
                                  )}
                                {goods.use_integral != 0 &&
                                  original_price != '0.00' && <span>+</span>}
                                {goods.use_integral != 0 && (
                                  <span>{goods.use_integral + '积分'}</span>
                                )}
                              </React.Fragment>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
            {exchangeCouponData.hasSelectGoods && (
              <div className="preview-goods-order-item">
                <img
                  className="preview-goods-cover"
                  src={exchangeCouponData.goodsInfo.cover}
                  mode="aspectFill"
                />
                <div className="preview-goods-content">
                  <div className="preview-goods-title">
                    {exchangeCouponData.goodsInfo.title}
                  </div>
                  {exchangeCouponData.goodsInfo.model_value_str && (
                    <div className="preview-goods-model">
                      {exchangeCouponData.goodsInfo.model_value_str}
                    </div>
                  )}
                  <div className="preview-quantity-section">
                    <div className="gift-text">赠品</div>
                    <div className="quantity pull-right">
                      <span>数量：</span>
                      <span className="buy-goods-count">1</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="preview-goods-order-section">
            <div style={convertLineStyleData('color:#333;margin-bottom:10px;')}>买家留言</div>
            <textarea
              value={orderRemark}
              maxLength="30"
              onInput={this.remarkInput}
              placeholder="买家留言"
            ></textarea>
          </div>
          {need_user_address == '1' ? (
            <div
              className="preview-goods-order-section"
              hidden={is_self_delivery == 1}
            >
              {selectAddress.id ? (
                <React.Fragment>
                  <div style={convertLineStyleData('position:relative;')}>
                    <div style={convertLineStyleData('margin-bottom:7px;width:250px;')}>
                      {selectAddress.address_info.name +
                        ' ' +
                        selectAddress.address_info.contact}
                    </div>
                    <div>
                      {selectAddress.address_info.province.text +
                        selectAddress.address_info.city.text +
                        selectAddress.address_info.district.text +
                        selectAddress.address_info.detailAddress}
                    </div>
                    <div className="preview-address-options">
                      <span
                        style={convertLineStyleData('margin-right:15px;')}
                        onClick={this.goToMyAddress}
                        data-address-id={selectAddress.id}
                      >
                        更换
                      </span>
                      <span onClick={this.showAddAddress}>添加个人信息</span>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <div className="pull-right ico-moon icon-rightarrow"></div>
                    <div onClick={this.showAddAddress}>添加个人信息</div>
                  </React.Fragment>
                )}
            </div>
          ) : (
              <div className="preview-goods-order-section">
                <div>个人信息</div>
                <label style={convertLineStyleData('margin-top:5px;color:#666;padding-left:10px;display:block;')}>
                  您的姓名
                <input
                    onBlur={this.appointmentUserName}
                    placeholder="请输入姓名"
                    className="appointment-user-name"
                    value={appointmentUserName}
                  />
                </label>
                <label style={convertLineStyleData('margin-top:5px;color:#666;padding-left:10px;display:block;')}>
                  联系方式
                <input
                    onBlur={this.appointmentUserPhone}
                    placeholder="请输入联系方式"
                    className="appointment-user-phone"
                    value={appointmentUserPhone}
                  />
                </label>
              </div>
            )}
          <div
            className="preview-goods-order-section"
            hidden={is_self_delivery == 0}
          >
            <div onClick={this.openStoreLocation}>
              <label className="ico-moon icon-location"></label>
              {shopAddress.region_string + shopAddress.shop_location}
            </div>
            <div style={convertLineStyleData('margin:12px 0;')} onClick={this.makeStorePhoneCall}>
              <label className="ico-moon icon-phone"></label>
              {shopAddress.shop_contact}
            </div>
            <div style={convertLineStyleData('font-size:12px;color:#aaa;margin-left:2px;')}>
              亲,勾选上门店自提,需要自己去门店取货哦！
            </div>
          </div>
          <div
            className="preview-goods-order-section"
            style={convertLineStyleData('margin-bottom:1px;')}
          >
            预约金额
            <span className="pull-right price-count">
              {'¥' + original_price}
            </span>
          </div>
          {!!discountList.length && (
            <div
              className="preview-goods-order-section"
              style={convertLineStyleData('margin-bottom:1px;')}
            >
              <div className="preview-section-title">
                优惠方式:<div className="ico-moon icon-rightarrow"></div>
              </div>
              <Picker
                onChange={this.discountChange}
                cols={1}
                value={[selectDiscountIndex]}
                data={discountList}
                style={convertLineStyleData('margin-bottom:-12rpx;')}
              >
                <div
                  className="select-discount-title"
                  style={convertLineStyleData('display: flex; justify-content: space-between')}
                >
                  <span className="pull-left">{selectDiscountInfo.name}</span>
                  <span
                    className="pull-right"
                    hidden={selectDiscountIndex == 0}
                  >
                    {'-¥' + discount_cut_price}
                  </span>
                </div>
              </Picker>
            </div>
          )}
          {balance != 0 && (
            <div className="preview-goods-order-section">
              <div className="use-balance-option">
                <span>使用储值金</span>
                <Switch
                  className="pull-right"
                  checked={useBalance}
                  onChange={this.useBalanceChange}
                ></Switch>
              </div>
              <div
                hidden={!useBalance}
                className="select-discount-title"
                style={convertLineStyleData('margin-top:9px;margin-bottom:-12rpx;')}
              >
                储值金抵现
                <span className="pull-right">{'- ¥' + deduction}</span>
              </div>
            </div>
          )}
          {!noAdditionalInfo && (
            <div
              className="preview-goods-order-section"
              onClick={this.goToAdditionalInfo}
            >
              补充信息
              <div
                className="ico-moon icon-rightarrow pull-right"
                style={convertLineStyleData('color:#aaa;')}
              ></div>
            </div>
          )}
          <div className="bottom-nav">
            <div className="preview-goods-total-price">
              合计:<span className="price-count">{'¥' + totalPayment}</span>
            </div>
            <form>
              <button type="button" onClick={this.confirmPayment}>去付款</button>
            </form>
          </div>
          {/* TODO
            <ExchangeCouponUseDialogTmpl
            data={exchangeCouponData}
          ></ExchangeCouponUseDialogTmpl> */}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-appointment-order/PreviewAppointmentOrder.jsx